import {Stack, useColorModeValue} from "@chakra-ui/react";
import { BiMessageRoundedError } from "react-icons/all";

import { Icon } from "components/Icon";
import { useGetThemeColors } from "ChakraTheme";

import { IChildrenProp } from "types/IChildrenProp";
import { MessageContainer } from "./MessageContainer";

interface IProps extends IChildrenProp {}

const ErrorWidget = ({ children }: IProps) => {
  const colors = useGetThemeColors();

  const redColor = useColorModeValue(colors.red[600], colors.red[300]);

  return (
    <MessageContainer>
      <Stack direction={{ base: "column", md: "row" }}>
        <Icon
          w={{ base: 50, md: 100 }}
          h={{ base: 50, md: 100 }}
          alignSelf="center"
          icon={BiMessageRoundedError}
          color={redColor}
        />
        {children}
      </Stack>
    </MessageContainer>
  );
};

export { ErrorWidget };
